var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_906_25473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9329 13.041C19.7441 14.481 19.1669 15.8424 18.2631 16.9792C17.3594 18.116 16.1632 18.9854 14.8029 19.494C13.4426 20.0027 11.9695 20.1315 10.5416 19.8666C9.11368 19.6017 7.7848 18.9531 6.69749 17.9903C5.61018 17.0276 4.80545 15.787 4.36961 14.4017C3.93377 13.0163 3.88326 11.5385 4.22349 10.1266C4.56373 8.71473 5.28188 7.42211 6.30091 6.38737C7.31995 5.35263 8.60144 4.6148 10.0079 4.25301C13.9069 3.25301 17.9429 5.26001 19.4329 9.00001",
    stroke: "#20262B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4V9H15",
    stroke: "#20262B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_906_25473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.e0129ce8efcabf99ba02832a757c2c50.svg";
export { ForwardRef as ReactComponent };